/** Canonical dev tester account (DB user id 1, username player1). */
export const DEV_PLAYER1_USER_ID = 1;

function isPlayer1Username(value) {
  return typeof value === 'string' && value.trim().toLowerCase() === 'player1';
}

function isDevPlayer1UserId(userId) {
  if (userId == null || userId === '') {
    return false;
  }
  const parsed = Number(userId);
  return !Number.isNaN(parsed) && parsed === DEV_PLAYER1_USER_ID;
}

function readStoredDevPlayerIdentity() {
  if (typeof window === 'undefined') {
    return { username: null, userId: null };
  }
  return {
    username: localStorage.getItem('user'),
    userId: localStorage.getItem('userId'),
  };
}

/**
 * True when the logged-in account is the dev tester `player1`.
 * Accepts username string, `{ username, userId }` from App, or falls back to localStorage.
 */
export function isPlayer1DevUser(user) {
  if (typeof user === 'string') {
    if (isPlayer1Username(user)) {
      return true;
    }
    if (isDevPlayer1UserId(user)) {
      return true;
    }
  }

  if (user != null && typeof user === 'object') {
    if (isPlayer1Username(user.username)) {
      return true;
    }
    if (isDevPlayer1UserId(user.userId ?? user.id)) {
      return true;
    }
  }

  const stored = readStoredDevPlayerIdentity();
  if (isPlayer1Username(stored.username)) {
    return true;
  }
  if (isDevPlayer1UserId(stored.userId)) {
    return true;
  }

  return false;
}

export function resolvePlayer1DisplayUsername(user) {
  if (typeof user === 'string') {
    return user;
  }
  if (user != null && typeof user === 'object' && user.username) {
    return user.username;
  }
  const stored = readStoredDevPlayerIdentity();
  return stored.username ?? '';
}
